import i18n from "../i18n";

// عكس الإشعار الوارد داخل التطبيق إلى إشعار نظام على الجوال/سطح المكتب بينما التطبيق مفتوح،
// دون انتظار وصول FCM بالخلفية. يعمل على PWA متى مُنح الإذن.
const isAr = () => (i18n.language || "ar").startsWith("ar");

export const notifTitle = (item) => {
  const d = item.data || {};
  if (item.type === "platform_broadcast")
    return (isAr() ? d.title_ar || d.title_en : d.title_en || d.title_ar) || d.title || i18n.t("notifications.broadcastTitle");
  return i18n.t(`notifications.type.${item.type}`, { defaultValue: i18n.t("notifications.title") });
};

export const notifBody = (item) => {
  const d = item.data || {};
  if (item.type === "platform_broadcast")
    return (isAr() ? d.body_ar || d.body_en : d.body_en || d.body_ar) || d.body || "";
  if (item.type.startsWith("penalty_") || item.type.startsWith("bonus_"))
    return (isAr() ? d.message_ar : d.message_en) || d.message_ar || "";
  return "";
};

export const mirrorToSystem = async (items, seen) => {
  if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
  const fresh = (items || []).filter((i) => !i.read && !seen.has(i.id));
  if (!fresh.length) return;
  // ready قد لا يُحسم إن لم يتحكّم أي عامل خدمة بعد؛ ننتظره 1.5ث ثم نعود لإشعار غير دائم.
  const reg = await Promise.race([
    navigator.serviceWorker?.ready,
    new Promise((r) => setTimeout(() => r(null), 1500)),
  ]).catch(() => null);
  for (const item of fresh) {
    seen.add(item.id);
    const opts = {
      body: notifBody(item), icon: "/icon-192.png", badge: "/icon-192.png",
      tag: item.id, dir: isAr() ? "rtl" : "ltr", lang: i18n.language || "ar", data: { url: "/" },
    };
    try {
      if (reg?.showNotification) await reg.showNotification(notifTitle(item), opts);
      else new Notification(notifTitle(item), opts);
    } catch {
      /* الإذن سُحب أو المنصّة لا تدعم — نتجاهل بهدوء */
    }
  }
};
